// imports
import JsonApiCollection from '$dependencies/JsonApiCollection';
import BinLocationTypeModel from '$models/bin/BinLocationTypeModel';
import Config from '$root/Config';

// class definition
export default class BinLocationTypeCollection extends JsonApiCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || BinLocationTypeModel;
		args.config = {
			url: Config.getUrl('binLocationTypes'),
		};
		args.jsonApi = { order: { weight: 'asc' } };
		// call super constructor
		super(args);
	}
}
